import { Button$PressEvent } from "sap/m/Button";
import BaseController from "../controller/BaseController";
import ObjectPageSubSection from "sap/uxap/ObjectPageSubSection";
import { ObjectPageSubSectionMode } from "sap/uxap/library";
import JSONModel from "sap/ui/model/json/JSONModel";
import { EnvironmentService } from "../service/Environment.service";
import MessageBox from "sap/m/MessageBox";
import { ListItemBase$PressEvent } from "sap/m/ListItemBase";
import Dialog from "sap/m/Dialog";
import { Button$ClickEvent } from "sap/ui/webc/main/Button";
import { ErrorHandler } from "../service/ErrorHandler.service";

/**
 * @namespace com.unitrade.crm.blocks
 */
export default class BelegListBlock extends BaseController {
  private _oModel: JSONModel;
  private _oMoreModel: JSONModel;
  private _oBelegListeDialog: Dialog;
  private _oMetaModel: JSONModel;

  onInit(): void {
    this._oModel = new JSONModel([]);
    this._oMoreModel = new JSONModel([]);
    this._oMetaModel = new JSONModel({ busy: false, busyMore: false });
    this.setModel(this._oModel);
    this.setModel(this._oMoreModel, "more");
    this.setModel(this._oMetaModel, "meta");
    this.getView().attachModelContextChange(null, this.onModelContextChange.bind(this));
  }

  handleExpandCollapsePress = (oEvent: Button$PressEvent) => {
    const parentBlock = (this as any).oParentBlock as ObjectPageSubSection;
    const sNewMode = parentBlock.getMode() === ObjectPageSubSectionMode.Collapsed ? ObjectPageSubSectionMode.Expanded : ObjectPageSubSectionMode.Collapsed;
    parentBlock.setMode(sNewMode);
  };

  async onModelContextChange(oEvent: Event) {
    const oCustomerModel = this.getModel("Customer");
    if (oCustomerModel) {
      try {
        this._oModel.setData([]);
        this._oMoreModel.setData([]);
        this._oMetaModel.setData({ busy: false, busyMore: false });
        const kundId = oCustomerModel.getProperty("/id");
        const kundLfd = oCustomerModel.getProperty("/lfd");
        if (kundId && kundLfd) {
          this._oMetaModel.setProperty("/busy", true);
          await this._oModel.loadData(`${EnvironmentService.getBaseUrl()}/beleg/list/${kundId}/${kundLfd}/10`);
        }
      } catch (ex: any) {
        ErrorHandler.handleError(ex, { message: "Fehler beim Laden der Belege" });
      } finally {
        this._oMetaModel.setProperty("/busy", false);
      }
    }
  }

  public onBelegPress(oEvent: ListItemBase$PressEvent) {
    const oListItem = oEvent.getSource();
    const oBindingCOntext = oListItem.getBindingContext() ?? oListItem.getBindingContext("more");
    const belegart = oBindingCOntext.getProperty("belegart");
    const belegnummer = oBindingCOntext.getProperty("belegnummer");

    this.getOwnerComponent().getRouter().navTo("beleg", { artPath: belegart, idPath: belegnummer });
  }

  onDisplayMoreButtonClick = async (oEvent: Button$ClickEvent) => {
    if (!this._oBelegListeDialog) {
      this._oBelegListeDialog = (await this.loadFragment({ name: "com.unitrade.crm.fragments.BelegListeDialog" })) as Dialog;
    }

    this._oBelegListeDialog.open();
    const oCustomerModel = this.getModel("Customer");

    const kundId = oCustomerModel.getProperty("/id");
    const kundLfd = oCustomerModel.getProperty("/lfd");
    if (kundId && kundLfd) {
      try {
        this._oMetaModel.setProperty("/busyMore", true);
        await this._oMoreModel.loadData(`${EnvironmentService.getBaseUrl()}/beleg/list/${kundId}/${kundLfd}/100`);
      } catch (ex: any) {
        ErrorHandler.handleError(ex, { message: "Fehler beim Laden der Belege" });
      } finally {
        this._oMetaModel.setProperty("/busyMore", false);
      }
    }
  };

  dialogDisplayMoreCancelPress = (oEvent: Button$PressEvent) => {
    if (this._oBelegListeDialog) {
      this._oBelegListeDialog.close();
    }
  };
}
